import { render } from "./Clock.vue?vue&type=template&id=0775adc1&scoped=true"
import script from "./Clock.vue?vue&type=script&lang=js"
export * from "./Clock.vue?vue&type=script&lang=js"

import "./Clock.vue?vue&type=style&index=0&id=0775adc1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0775adc1"]])

export default __exports__